export default {
      id: "pikto-fb-usage",
      viewBox: "0 0 3.18 3.18",
      url: __webpack_public_path__ + "../images/sprites.svg#pikto-fb",
      toString: function () {
        return this.url;
      }
    }